// extracted by mini-css-extract-plugin
export default {"choose":"SelectAction_choose__ghs38"};